import { Children } from "react";

import { cx } from "@/utils";
import range from "@/utils/range";
import { Skeleton } from "./layout";

export const LoadingStats = ({ title, className, rows = 4, cols = 1 }) => {
  return (
    <div className={cx(className)}>
      {title && (
        <h3 className="mb-4 text-lg font-medium text-gray-800">{title}</h3>
      )}
      <div className={`grid grid-cols-${cols}`}>
        {Children.toArray(
          range(rows).map(() => (
            <div className="border-cp-grey-300 flex w-full justify-between border-b py-2">
              <Skeleton className="flex h-5 w-52 rounded-md" />
              <Skeleton className="flex h-5 w-52 rounded-md" />
            </div>
          )),
        )}
      </div>
    </div>
  );
};

export default function Stats({ title, items = [], className, cols = 1 }) {
  return (
    <div className={cx(className)}>
      {title && (
        <h3 className="mb-4 text-lg font-medium text-gray-800">{title}</h3>
      )}
      <div className={`grid grid-cols-${cols} gap-x-10`}>
        {Children.toArray(
          items.map((item) => (
            <p className="text-cp-grey-600 border-cp-grey-300 flex justify-between border-b py-2 text-base">
              {item.label}
              <span className={cx(item.className)}>{item.value}</span>
            </p>
          )),
        )}
      </div>
    </div>
  );
}
